import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
const menu = {
  '新增检测': RoutePathConstants.NEW_DETECTION,
  '预检记录': RoutePathConstants.PRE_INSPECTION_RECORD,
  '完工记录': RoutePathConstants.COMPLETION_RECORD

}
export default {
  data () {
    return {
      radio1: ''
    }
  },

  methods: {
    clickMenu (val) {
      this.$router.push({
        path: menu[val]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/components/pre-inspection.js